import React from 'react';
export function Footer() {
  return <footer className="py-8 md:py-16 border-t border-[#D5DCE5] bg-[#F1F4F8] pb-24 md:pb-16" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-19">
        <div className="inline-flex items-center gap-2 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full bg-white border border-[#D5DCE5] text-[#1E3A5F] text-[10px] sm:text-xs font-bold tracking-[0.2em] sm:tracking-[0.25em] mb-4 sm:mb-6 uppercase" data-id="element-20">
          Kit Anticontracturas™
        </div>

        <p className="text-[#1A2433] font-medium text-sm sm:text-base md:text-lg mb-1.5 sm:mb-2 leading-snug" style={{
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-21">
          El sistema N°1 para oficinistas argentinos que quieren{' '}
          <span className="italic" data-id="element-22">trabajar sin pagar con el cuerpo</span>.
        </p>
        <p className="text-[#4A5568] text-xs sm:text-base mb-6 sm:mb-10 italic" data-id="element-23">
          Porque tener el trabajo que elegiste no debería costarte la salud.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-1.5 sm:gap-6 text-[11px] sm:text-sm text-[#4A5568] mb-6 sm:mb-10" data-id="element-24">
          <a href="mailto:soporte@kitanticontracturas.com" className="hover:text-[#1E3A5F] transition-colors" data-id="element-25">
            📧 soporte@kitanticontracturas.com
          </a>
          <span className="hidden md:inline text-[#D5DCE5]" data-id="element-26">|</span>
          <a href="https://kitanticontracturas.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1E3A5F] transition-colors" data-id="element-27">
            🌐 kitanticontracturas.com
          </a>
        </div>

        <div className="text-[#4A5568] text-[10px] sm:text-sm space-y-0.5 sm:space-y-1 mb-6 sm:mb-12" data-id="element-28">
          <p data-id="element-29">© Kit Anticontracturas Para Oficina™ 2025</p>
          <p className="text-[9px] sm:text-xs" data-id="element-30">
            Todos los derechos reservados. Prohibida la reproducción sin
            autorización.
          </p>
        </div>

        <div className="pt-5 sm:pt-8 border-t border-[#D5DCE5] max-w-2xl mx-auto" data-id="element-31">
          <p className="text-[#1E3A5F] italic font-medium text-xs sm:text-base md:text-lg leading-snug sm:leading-relaxed" style={{
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-32">
            "Tu cuerpo no es el precio de tu trabajo. Es tu herramienta más
            importante. El sistema está acá. Solo falta que lo enciendas."
          </p>
        </div>
      </div>
    </footer>;
}